import { createWebHistory, createRouter } from "vue-router";
import { authGuard } from "./guards";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import VabeneAddUserPage from "@/pages/Vabene/Users/VabeneAddUserPage.vue";
import VaBeneUserListPage from "@/pages/Vabene/Users/VaBeneUserListPage.vue";
import VabeneRestaurantListPage from "@/pages/Vabene/Restaurant/VabeneRestaurantListPage.vue";
import VabeneAddRestaurantPage from "@/pages/Vabene/Restaurant/VabeneAddRestaurantPage.vue";
import VabeneOrderListPage from "@/pages/Vabene/Order/VabeneOrderListPage.vue";
import VabeneAddOrderPage from "@/pages/Vabene/Order/VabeneAddOrderPage.vue";
import VabeneOrderDetailsPage from "@/pages/Vabene/Order/VabeneOrderDetailsPage.vue";
import POSMain from "@/components/Vabene/POS/Modern/views/POSMain.vue";
import VabeneTransactionListPage from "@/pages/Vabene/Order/VabeneTransactionListPage.vue";
import VabeneTransactionDetailsPage from "@/pages/Vabene/Order/VabeneTransactionDetailsPage.vue";
import VabeneDashPage from "@/pages/Vabene/Dashboard/VabeneDashPage.vue";
import VabeneWebThemePage from "@/pages/Franchise/VabeneWebThemePage.vue";
import VabeneAddTimeSlotPage from "@/pages/Vabene/TimeSlot/VabeneAddTimeSlotPage.vue";
import VaBeneCategorieListPage from "@/pages/Vabene/Categorie/VaBeneCategorieListPage.vue";
import VabeneAddCategoriePage from "@/pages/Vabene/Categorie/VabeneAddCategoriePage.vue";
import VaBeneIngredientListPage from "@/pages/Vabene/Ingredient/VaBeneIngredientListPage.vue";
import VabeneAddIngredientPage from "@/pages/Vabene/Ingredient/VabeneAddIngredientPage.vue";
import VaBeneIngredientTypeListPage from "@/pages/Vabene/Ingredient/VaBeneIngredientTypeListPage.vue";
import VaBeneIngredientCategoryListPage from "@/pages/Vabene/Ingredient/VaBeneIngredientCategoryListPage.vue";
import VaBeneSupplementListPage from "@/pages/Vabene/Supplement/VaBeneSupplementListPage.vue";
import VabeneAddSupplementPage from "@/pages/Vabene/Supplement/VabeneAddSupplementPage.vue";
import VaBeneSupplementTypeListPage from "@/pages/Vabene/Supplement/VaBeneSupplementTypeListPage.vue";
import VaBeneFeatureListPage from "@/pages/Vabene/Feature/VaBeneFeatureListPage.vue";
import VabeneAddFeaturePage from "@/pages/Vabene/Feature/VabeneAddFeaturePage.vue";
import VabeneOrderReportSellPage from "@/pages/Vabene/Order/VabeneOrderReportSellPage.vue";
import VabeneAdvancedAnalyticPage from "@/pages/Vabene/Order/VabeneAdvancedAnalyticPage.vue";
import VaBeneProductListPage from "@/pages/Vabene/Produit/VaBeneProductListPage.vue";
import VabeneAddProductPage from "@/pages/Vabene/Produit/VabeneAddProductPage.vue";
import VaBeneCustomerListPage from "@/pages/Vabene/Customer/VaBeneCustomerListPage.vue";
import VabeneAddCustomerPage from "@/pages/Vabene/Customer/VabeneAddCustomerPage.vue";
import VabeneEditCustomerPage from "@/pages/Vabene/Customer/VabeneEditCustomerPage.vue";
import VabeneAddCampagePage from "@/pages/Vabene/Campagne/VabeneAddCampagePage.vue";
import VaBeneCampagneListPage from "@/pages/Vabene/Campagne/VaBeneCampagneListPage.vue";
import VabeneAddNotificationPage from "@/pages/Vabene/Notification/VabeneAddNotificationPage.vue";
import VaBeneNotificationListPage from "@/pages/Vabene/Notification/VaBeneNotificationListPage.vue";
import MotPasseOubliePage from "@/pages/Authentication/MotPasseOubliePage.vue";
import VabeneAddCouponPage from "@/pages/Vabene/Coupon/VabeneAddCouponPage.vue";
import VaBeneCouponListPage from "@/pages/Vabene/Coupon/VaBeneCouponListPage.vue";
import VabeneIngredientBaseListPage from "@/pages/Vabene/IngredientBase/VabeneIngredientBaseListPage.vue";
import VaBeneProgrammeAffiliationListPage from "@/pages/Vabene/Programme/VaBeneProgrammeAffiliationListPage.vue";
import VabeneAddProgrammePage from "@/pages/Vabene/Programme/VabeneAddProgrammePage.vue";
import VabeneParrainagePage from "@/pages/Vabene/Programme/VabeneParrainagePage.vue";
import VabeneFidelitePage from "@/pages/Vabene/Programme/VabeneFidelitePage.vue";
import VabeneAdminDashPage from "@/pages/Vabene/Dashboard/VabeneAdminDashPage.vue";
import OmnesightAIPage from "@/pages/Vabene/Applications/OmnesightAIPage.vue";
import FranchiseLoyaltyConfigPage from "@/pages/Vabene/Programme/FranchiseLoyaltyConfigPage.vue";
import LoyaltyProductsPage from "@/pages/Vabene/Programme/LoyaltyProductsPage.vue";
import LoyaltyProductFormPage from "@/pages/Vabene/Programme/LoyaltyProductFormPage.vue";
import VabeneLoyaltyReportPage from "@/pages/Vabene/Programme/VabeneLoyaltyReportPage.vue";
import VaBeneMarketingDashPage from "@/pages/Vabene/Dashboard/VaBeneMarketingDashPage.vue";
import MessagesAutomatiquesPage from "@/pages/Vabene/Marketing/MessagesAutomatiquesPage.vue";
import VabeneUpsellSettingsPage from "@/pages/Vabene/Marketing/VabeneUpsellSettingsPage.vue";
import VabeneBlogPostsPage from "@/pages/Vabene/Marketing/VabeneBlogPostsPage.vue";
import VabeneBlogPostFormPage from "@/pages/Vabene/Marketing/VabeneBlogPostFormPage.vue";
import VabeneFaqPage from "@/pages/Vabene/Marketing/VabeneFaqPage.vue";
import VabeneGalleryPage from "@/pages/Vabene/Marketing/VabeneGalleryPage.vue";
import VabeneTraiteurPage from "@/pages/Vabene/Marketing/VabeneTraiteurPage.vue";
import VabeneReviewPage from "@/pages/Vabene/Marketing/VabeneReviewPage.vue";
import VabenePagesListPage from "@/pages/Vabene/Marketing/Pages/VabenePagesListPage.vue";
import VabenePageFormPage from "@/pages/Vabene/Marketing/Pages/VabenePageFormPage.vue";
import VabenePageStudioPage from "@/pages/Vabene/Marketing/Pages/VabenePageStudioPage.vue";
import VabeneMarketingSettingsPage from "@/pages/Vabene/Marketing/VabeneMarketingSettingsPage.vue";
import VabeneIntegrationsPage from "@/pages/Vabene/Settings/VabeneIntegrationsPage.vue";
import VabeneReferralReportPage from "@/pages/Vabene/Programme/VabeneReferralReportPage.vue";
import VabeneGiftCardsPage from "@/pages/Vabene/Marketing/VabeneGiftCardsPage.vue";
import VabeneFormsListPage from "@/pages/Vabene/Marketing/Forms/VabeneFormsListPage.vue";
import VabeneFormEditorPage from "@/pages/Vabene/Marketing/Forms/VabeneFormEditorPage.vue";
import VabeneInfoFranchisePage from "@/pages/Vabene/Franchise/VabeneInfoFranchisePage.vue";
import VabeneRestaurantClosuresPage from "@/pages/Vabene/Closures/VabeneRestaurantClosuresPage.vue";
import VabeneDailyClosureListPage from "@/pages/Vabene/Closures/VabeneDailyClosureListPage.vue";
import VabeneDeletedOrdersPage from "@/pages/Vabene/Order/VabeneDeletedOrdersPage.vue";
const routes = [
    {
        path: "/clotures-journalieres",
        name: "VabeneDailyClosureListPage",
        component: VabeneDailyClosureListPage,
    },
    {
        path: "/home",
        name: "VabeneDashPage",
        component: VabeneDashPage,
    },
    {
        path: "/admin-dashboard",
        name: "VabeneAdminDashPage",
        component: VabeneAdminDashPage,
    },
    {
        path: "/marketing-dashboard",
        name: "VaBeneMarketingDashPage",
        component: VaBeneMarketingDashPage,
    },
    {
        path: "/marketing/attribution",
        name: "MarketingAttributionPage",
        component: () => import("@/pages/Vabene/Marketing/MarketingAttributionPage.vue"),
    },
    {
        path: "/marketing/messages-automatiques",
        name: "MessagesAutomatiquesPage",
        component: MessagesAutomatiquesPage,
    },
    {
        path: "/marketing/upsell",
        name: "VabeneUpsellSettingsPage",
        component: VabeneUpsellSettingsPage,
    },
    {
        path: "/marketing/blog",
        name: "VabeneBlogPostsPage",
        component: VabeneBlogPostsPage,
    },
    {
        path: "/marketing/blog/:action/:postId?",
        name: "VabeneBlogPostFormPage",
        component: VabeneBlogPostFormPage,
        props: (route) => ({
            action: String(route.params.action),
            postId: route.params.postId ? String(route.params.postId) : undefined,
        }),
    },
    {
        path: "/marketing/faq",
        name: "VabeneFaqPage",
        component: VabeneFaqPage,
    },
    {
        path: "/marketing/gallery",
        name: "VabeneGalleryPage",
        component: VabeneGalleryPage,
    },
    {
        path: "/marketing/traiteur",
        name: "VabeneTraiteurPage",
        component: VabeneTraiteurPage,
    },
    {
        path: "/marketing/reviews",
        name: "VabeneReviewPage",
        component: VabeneReviewPage,
    },
    {
        path: "/marketing/gift-cards",
        name: "VabeneGiftCardsPage",
        component: VabeneGiftCardsPage,
    },
    {
        path: "/marketing/settings",
        name: "VabeneMarketingSettingsPage",
        component: VabeneMarketingSettingsPage,
    },
    {
        path: "/marketing/pages",
        name: "VabenePagesListPage",
        component: VabenePagesListPage,
    },
    {
        path: "/marketing/pages/:action/:id?",
        name: "VabenePageFormPage",
        component: VabenePageFormPage,
        props: (route) => ({
            action: String(route.params.action),
            id: route.params.id ? String(route.params.id) : undefined,
        }),
    },
    {
        path: "/marketing/pages/studio/:id",
        name: "VabenePageStudioPage",
        component: VabenePageStudioPage,
        props: (route) => ({
            id: String(route.params.id),
        }),
    },
    {
        path: "/marketing/forms",
        name: "VabeneFormsListPage",
        component: VabeneFormsListPage,
    },
    {
        path: "/marketing/forms/:action/:id?",
        name: "VabeneFormEditorPage",
        component: VabeneFormEditorPage,
        props: (route) => ({
            action: String(route.params.action),
            id: route.params.id ? String(route.params.id) : undefined,
        }),
    },
    {
        path: "/settings/theme",
        name: "VabeneWebThemePage",
        component: VabeneWebThemePage,
    },
    {
        path: "/settings/general",
        name: "VabeneInfoFranchisePage",
        component: VabeneInfoFranchisePage,
    },
    {
        path: "/settings/integrations",
        name: "VabeneIntegrationsPage",
        component: VabeneIntegrationsPage,
    },
    {
        path: "/password-oublie",
        name: "MotPasseOubliePage",
        component: MotPasseOubliePage,
    },
    {
        path: "/reset-password",
        name: "ResetPasswordPage",
        component: () => import("@/pages/Authentication/ResetPasswordPage.vue"),
    },
    {
        path: "/affiliation-programmes",
        name: "VaBeneProgrammeAffiliationListPage",
        component: VaBeneProgrammeAffiliationListPage,
    },
    {
        path: "/parrainage",
        name: "VabeneParrainagePage",
        component: VabeneParrainagePage,
    },
    {
        path: "/fidelite",
        name: "VabeneFidelitePage",
        component: VabeneFidelitePage,
    },
    {
        path: "/fidelite-strategie",
        name: "FranchiseLoyaltyConfigPage",
        component: FranchiseLoyaltyConfigPage,
    },
    {
        path: "/fidelite-paliers",
        name: "RestaurantLoyaltyTiersPage",
        component: () => import("@/pages/Vabene/Programme/RestaurantLoyaltyTiersPage.vue"),
    },
    {
        path: "/fidelite-produits",
        name: "LoyaltyProductsPage",
        component: LoyaltyProductsPage,
    },
    {
        path: "/fidelite-produits/:action/:productId?",
        name: "LoyaltyProductFormPage",
        component: LoyaltyProductFormPage,
        props: (route) => ({
            action: String(route.params.action),
            productId: route.params.productId
                ? String(route.params.productId)
                : undefined,
        }),
    },
    {
        path: "/loyalty-report",
        name: "VabeneLoyaltyReportPage",
        component: VabeneLoyaltyReportPage,
    },
    {
        path: "/rapport-parrainage",
        name: "VabeneReferralReportPage",
        component: VabeneReferralReportPage,
    },
    {
        path: "/ajout-programme/:action/:categorieID?",
        name: "VabeneAddProgrammePage",
        component: VabeneAddProgrammePage,
        props: (route) => ({
            action: String(route.params.action),
            categorieID: route.params.categorieID
                ? String(route.params.categorieID)
                : undefined,
        }),
    },
    {
        path: "/omnesight-ai",
        name: "OmnesightAIPage",
        component: OmnesightAIPage,
    },
    {
        path: "/utilisateur-list",
        name: "VaBeneUserListPage",
        component: VaBeneUserListPage,
    },
    {
        path: "/ajout-utilisateur/:action/:userID?",
        name: "VabeneAddUserPage",
        component: VabeneAddUserPage,
        props: (route) => ({
            action: String(route.params.action),
            userID: route.params.userID ? String(route.params.userID) : undefined,
        }),
    },
    {
        path: "/restaurant-list",
        name: "VabeneRestaurantListPage",
        component: VabeneRestaurantListPage,
    },
    {
        path: "/ajout-restaurant/:action/:restaurantID?",
        name: "VabeneAddRestaurantPage",
        component: VabeneAddRestaurantPage,
        props: (route) => ({
            action: String(route.params.action),
            restaurantID: route.params.restaurantID
                ? String(route.params.restaurantID)
                : undefined,
        }),
    },
    {
        path: "/delivery-zones",
        name: "VabeneDeliveryZoneListPage",
        component: () => import("@/pages/Vabene/DeliveryZone/VabeneDeliveryZoneListPage.vue"),
    },
    {
        path: "/delivery-zones/add",
        name: "VabeneAddDeliveryZonePage",
        component: () => import("@/pages/Vabene/DeliveryZone/VabeneAddDeliveryZonePage.vue"),
    },
    {
        path: "/delivery-zones/edit/:zoneID",
        name: "VabeneEditDeliveryZonePage",
        component: () => import("@/pages/Vabene/DeliveryZone/VabeneAddDeliveryZonePage.vue"),
    },
    {
        path: "/delivery-zones/:zoneId/postal-codes",
        name: "VabenePostalCodesPage",
        component: () => import("@/pages/Vabene/DeliveryZone/VabenePostalCodesPage.vue"),
    },
    {
        path: "/opening-hours",
        name: "VabeneOpeningHoursPage",
        component: () => import("@/pages/Vabene/OpeningHours/VabeneOpeningHoursPage.vue"),
    },
    {
        path: "/opening-hours/add",
        name: "VabeneAddOpeningHoursPage",
        component: () => import("@/pages/Vabene/OpeningHours/VabeneAddOpeningHoursPage.vue"),
    },
    {
        path: "/opening-hours/edit",
        name: "VabeneEditOpeningHoursPage",
        component: () => import("@/pages/Vabene/OpeningHours/VabeneAddOpeningHoursPage.vue"),
    },
    {
        path: "/special-closures",
        name: "VabeneRestaurantClosuresPage",
        component: VabeneRestaurantClosuresPage,
    },
    {
        path: "/payment-methods",
        name: "VabenePaymentMethodsPage",
        component: () => import("@/pages/Vabene/PaymentMethods/VabenePaymentMethodsPage.vue"),
    },
    {
        path: "/order-list",
        name: "VabeneOrderListPage",
        component: VabeneOrderListPage,
    },
    {
        path: "/ajout-commande",
        name: "VabeneAddOrderPage",
        component: VabeneAddOrderPage,
    },
    {
        path: "/pos",
        name: "POSModern",
        component: POSMain,
    },
    {
        path: "/rapport-vente",
        name: "VabeneOrderReportSellPage",
        component: VabeneOrderReportSellPage,
    },
    {
        path: "/rapport-vente-avance",
        name: "VabeneAdvancedAnalyticPage",
        component: VabeneAdvancedAnalyticPage,
    },
    {
        path: "/commandes-supprimees",
        name: "VabeneDeletedOrdersPage",
        component: VabeneDeletedOrdersPage,
    },
    {
        path: "/detail-commande/:commandeID",
        name: "VabeneOrderDetailsPage",
        component: VabeneOrderDetailsPage,
        props: (route) => ({
            commandeID: String(route.params.commandeID),
        }),
    },
    {
        path: "/transaction-list",
        name: "VabeneTransactionListPage",
        component: VabeneTransactionListPage,
    },
    {
        path: "/detail-transaction/:transactionID",
        name: "VabeneTransactionDetailsPage",
        component: VabeneTransactionDetailsPage,
        props: (route) => ({
            transactionID: String(route.params.transactionID),
        }),
    },
    {
        path: "/ajout-time-slot/:action/:timeSlotID?",
        name: "VabeneAddTimeSlotPage",
        component: VabeneAddTimeSlotPage,
        props: (route) => ({
            action: String(route.params.action),
            timeSlotID: route.params.timeSlotID
                ? String(route.params.timeSlotID)
                : undefined,
        }),
    },
    {
        path: "/categorie-list",
        name: "VaBeneCategorieListPage",
        component: VaBeneCategorieListPage,
    },
    {
        path: "/ajout-categorie/:action/:categorieID?",
        name: "VabeneAddCategoriePage",
        component: VabeneAddCategoriePage,
        props: (route) => ({
            action: String(route.params.action),
            categorieID: route.params.categorieID
                ? String(route.params.categorieID)
                : undefined,
        }),
    },
    {
        path: "/ingredient-list",
        name: "VaBeneIngredientListPage",
        component: VaBeneIngredientListPage,
    },
    {
        path: "/ajout-ingredient/:action/:ingredientID?",
        name: "VabeneAddIngredientPage",
        component: VabeneAddIngredientPage,
        props: (route) => ({
            action: String(route.params.action),
            ingredientID: route.params.ingredientID
                ? String(route.params.ingredientID)
                : undefined,
        }),
    },
    {
        path: "/ingredient-type-list",
        name: "VaBeneIngredientTypeListPage",
        component: VaBeneIngredientTypeListPage,
    },
    {
        path: "/ingredient-category-list",
        name: "VaBeneIngredientCategoryListPage",
        component: VaBeneIngredientCategoryListPage,
    },
    {
        path: "/supplement-list",
        name: "VaBeneSupplementListPage",
        component: VaBeneSupplementListPage,
    },
    {
        path: "/ajout-supplement/:action/:supplementID?",
        name: "VabeneAddSupplementPage",
        component: VabeneAddSupplementPage,
        props: (route) => ({
            action: String(route.params.action),
            supplementID: route.params.supplementID
                ? String(route.params.supplementID)
                : undefined,
        }),
    },
    {
        path: "/supplement-type-list",
        name: "VaBeneSupplementTypeListPage",
        component: VaBeneSupplementTypeListPage,
    },
    {
        path: "/feature-list",
        name: "VaBeneFeatureListPage",
        component: VaBeneFeatureListPage,
    },
    {
        path: "/ajout-feature/:action/:featureID?",
        name: "VabeneAddFeaturePage",
        component: VabeneAddFeaturePage,
        props: (route) => ({
            action: String(route.params.action),
            featureID: route.params.featureID
                ? String(route.params.featureID)
                : undefined,
        }),
    },
    {
        path: "/product-list",
        name: "VaBeneProductListPage",
        component: VaBeneProductListPage,
    },
    {
        path: "/ajout-product/:action/:productID?",
        name: "VabeneAddProductPage",
        component: VabeneAddProductPage,
        props: (route) => ({
            action: String(route.params.action),
            productID: route.params.productID
                ? String(route.params.productID)
                : undefined,
        }),
    },
    {
        path: "/customer-list",
        name: "VaBeneCustomerListPage",
        component: VaBeneCustomerListPage,
    },
    {
        path: "/customer/edit/:customerID",
        name: "VabeneEditCustomerPage",
        component: VabeneEditCustomerPage,
        props: true,
    },
    {
        path: "/customer/:action/:customerID?",
        name: "VabeneAddCustomerPage",
        component: VabeneAddCustomerPage,
        props: (route) => ({
            action: String(route.params.action),
            customerID: route.params.customerID
                ? String(route.params.customerID)
                : undefined,
        }),
    },
    {
        path: "/campagne-list",
        name: "VaBeneCampagneListPage",
        component: VaBeneCampagneListPage,
    },
    {
        path: "/ajout-campagne/:action/:campagneID?",
        name: "VabeneAddCampagePage",
        component: VabeneAddCampagePage,
        props: (route) => ({
            action: String(route.params.action),
            campagneID: route.params.campagneID
                ? String(route.params.campagneID)
                : undefined,
        }),
    },
    {
        path: "/notifications-sending",
        name: "VabeneNotificationListPage",
        component: VaBeneNotificationListPage,
    },
    {
        path: "/ajout-notification/:action/:notificationID?",
        name: "VabeneAddNotificationPage",
        component: VabeneAddNotificationPage,
        props: (route) => ({
            action: String(route.params.action),
            notificationID: route.params.notificationID
                ? String(route.params.notificationID)
                : undefined,
        }),
    },
    {
        path: "/list-coupon",
        name: "VaBeneCouponListPage",
        component: VaBeneCouponListPage,
    },
    {
        path: "/ajout-coupon/:action/:couponID?",
        name: "VabeneAddCouponPage",
        component: VabeneAddCouponPage,
        props: (route) => ({
            action: String(route.params.action),
            couponID: route.params.couponID
                ? String(route.params.couponID)
                : undefined,
        }),
    },
    {
        path: "/ingredient-base-list",
        name: "VabeneIngredientBaseListPage",
        component: VabeneIngredientBaseListPage,
    },
    {
        path: "/social/feed",
        name: "SocialFeedPage",
        component: () => import("@/pages/Vabene/Social/SocialFeedPage.vue"),
    },
    {
        path: "/social/posts",
        name: "SocialPostsListPage",
        component: () => import("@/pages/Vabene/Social/SocialPostsListPage.vue"),
    },
    {
        path: "/social/chat",
        name: "SocialChatPage",
        component: () => import("@/pages/Vabene/Social/SocialChatPage.vue"),
    },
    {
        path: "/social/configuration",
        name: "SocialAccountsPage",
        component: () => import("@/pages/Vabene/Social/SocialAccountsPage.vue"),
    },
    {
        path: "/",
        name: "LoginPage",
        component: LoginPage,
    },
];
const router = createRouter({
    history: createWebHistory(),
    linkExactActiveClass: "active",
    routes: routes,
    scrollBehavior() {
        return { top: 0, behavior: "smooth" };
    },
});
router.beforeEach(authGuard);
export default router;
